import withAemIntegration from "../../withAemIntegration";
import loadable from "../../utils/loadable";
const Component = loadable(() =>
  import("@lexus.com/ui/dist/modules/AllOffers")
);

const AllOffersEditConfig = {
  emptyLabel: "AllOffers",
  isEmpty: function (props) {
    return !props || !props.title || props.title.trim().length < 1;
  },
};

const transformData = ({
  isDealerSiteModule = false,
  ...props
}) => {
  const renderZipGate = window.editorMode || window.authoringMode;
  return {
    renderZipGate,
    isDealerSiteModule: !!JSON.parse(String(isDealerSiteModule)),
    ...props,
    offerLeadForm: {
      ...props.offerLeadForm,
      serverErrorMessaging: {
        errorHeader: props.offerLeadForm?.serviceDownMessage?.heading,
        errorDescription: props.offerLeadForm?.serviceDownMessage?.text,
      },
    },
  };
};

const AllOffers = (props) => {
  const data = transformData(props);
  return <Component {...data} />;
};

export default withAemIntegration("lexus/components/all-offers")(
  AllOffers,
  AllOffersEditConfig
);
